export default function Configure($stateProvider) {
    $stateProvider.state('seuils', {
        parent: 'common',
        url: '/seuils',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.ENVIRONNEMENT" | translate }}'
        }
    });

    $stateProvider.state('seuils.list', {
        url: '/list',
        template: '<references-controle></references-controle>',
        rights: { domain: 'seuils', right: 'read' },
        ncyBreadcrumb: {
            parent: 'seuils',
            label: '{{ "REFERENCES.BREADCRUMBS.REFERENCES_LIST" | translate}}'
        },
        navigation: {
            menu: 'environnement_theme_mes',
            translate: 'REFERENCES.BREADCRUMBS.REFERENCES_LIST',
            order: 6
        },
        search: 'REFERENCES.BREADCRUMBS.REFERENCES_LIST'
    });

    $stateProvider.state('seuils.list.detail', {
        url: '/{id}',
        template: '<reference-controle-detail></reference-controle-detail>',
        rights: { domain: 'seuils', right: 'read' },
        ncyBreadcrumb: {
            parent: 'seuils.list',
            label: '{{ "REFERENCES.BREADCRUMBS.REFERENCE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('seuils.new', {
        url: '/new',
        template: '<reference-controle-form></reference-controle-form>',
        rights: { domain: 'seuils', right: 'create' },
        ncyBreadcrumb: {
            parent: 'seuils.list',
            label: '{{ "REFERENCES.BREADCRUMBS.REFERENCE_NEW" | translate}}'
        },
        search: 'REFERENCES.BREADCRUMBS.REFERENCE_NEW'
    });

    $stateProvider.state('seuils.edit', {
        url: '/{id}/edit',
        template: '<reference-controle-form></reference-controle-form>',
        rights: { domain: 'seuils', right: 'update' },
        ncyBreadcrumb: {
            parent: 'seuils.list',
            label: '{{ "REFERENCES.BREADCRUMBS.REFERENCE_EDIT" | translate }}'
        }
    });

    $stateProvider.state('seuils.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: { parentState: 'seuils.new' },
        ncyBreadcrumb: {
            parent: 'seuils.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });

    $stateProvider.state('seuils.duplicate', {
        url: '/{id}/duplicate',
        template: '<reference-controle-form></reference-controle-form>',
        rights: { domain: 'seuils', right: 'create' },
        ncyBreadcrumb: {
            parent: 'seuils.list',
            label: '{{ "REFERENCES.BREADCRUMBS.REFERENCE_NEW" | translate}}'
        },
        params: {
            duplicate: true
        }
    });
}

Configure.$inject = ['$stateProvider'];
